import * as preact from 'preact'
const { h, Component } = preact
import PureComponent from '../../../lib/preact-pure-component'
import styles from './style.css'
import className from 'classnames'
interface Props {
  onClick: () => void
  active: boolean
}

export class ShowSourceButton extends PureComponent<Props, {}> {
  render() {
    const buttonClassNames = className(styles.button, { [styles.buttonActive]: this.props.active })
    return (
      <button className={buttonClassNames} onClick={this.props.onClick}>
        Kilde
      </button>
    )
  }
}
